import { create } from "zustand";

interface ChatbotStoreType {
  isChatbotOpen: boolean;
  hideChatbot: boolean;
  setIsChatbotOpen: (newIsChatbotOpen: boolean) => void;
  setHideChatbot: (newHideChatbot: boolean) => void;
}

const useChatbotStore = create<ChatbotStoreType>((set, get) => ({
  isChatbotOpen: false,
  hideChatbot: false,
  setIsChatbotOpen: (newIsChatbotOpen: boolean) => {
    set({ isChatbotOpen: newIsChatbotOpen });
  },
  setHideChatbot: (newHideChatbot: boolean) => {
    set({ hideChatbot: newHideChatbot });
  },
}));

export default useChatbotStore;
